export enum VTableRowStatus {
    Info,
    Success,
    Warning,
    Error,
    InProgress,
    Completed,
    Pending,
    Failure
}
